import { ProductType } from '../enums';

export type ProductTypeUrlSuffixIndex = 'family' | 'group' | 'product';

export const ProductTypeUrlSuffix: Record<ProductType, ProductTypeUrlSuffixIndex> = {
  [ProductType.Family]: 'family',
  [ProductType.Group]: 'group',
  [ProductType.Product]: 'product',
};
